import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { axios, useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';
import * as XLSX from 'xlsx';

// ══════════════════════════════════════════════════════════
// YARDIMCI FONKSİYONLAR
// ══════════════════════════════════════════════════════════
function formatTarih(str) {
  if (!str) return '—';
  return new Date(str).toLocaleDateString('tr-TR', { day: '2-digit', month: 'long', year: 'numeric' });
}
function formatSaat(str) {
  if (!str) return '—';
  return String(str).slice(0, 5);
}

// ══════════════════════════════════════════════════════════
// EXCEL EXPORT YARDIMCISI
// ══════════════════════════════════════════════════════════
function exportEtutYoklamaExcel(etut, katilimcilar) {
  if (!katilimcilar || katilimcilar.length === 0) {
    toast.error('İndirilecek katılımcı yok');
    return;
  }
  const data = katilimcilar.map((k, i) => ({
    'Sıra': i + 1,
    'Ad Soyad': `${k.ad} ${k.soyad}`,
    'Öğrenci No': k.ogrenci_no || '—',
    'Katılım Durumu': k.katildi === 1 ? 'Katıldı' : k.katildi === 0 ? 'Katılmadı' : 'Belirtilmedi',
  }));

  const ws = XLSX.utils.json_to_sheet(data);
  ws['!cols'] = [{ wch: 6 }, { wch: 24 }, { wch: 14 }, { wch: 16 }];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Yoklama');

  // Başlık satırı
  const baslik = [
    [`Etüt Yoklama Listesi`],
    [`Ders: ${etut?.ders_adi || '—'}`],
    [`Öğretmen: ${etut?.ogretmen_ad || ''} ${etut?.ogretmen_soyad || ''}`],
    [`Tarih: ${formatTarih(etut?.tarih)}  Saat: ${formatSaat(etut?.baslangic_saati)}${etut?.bitis_saati ? ' – ' + formatSaat(etut.bitis_saati) : ''}`],
    [`Salon: ${etut?.salon || 'Belirtilmedi'}`],
    [],
  ];
  const wsBaslik = XLSX.utils.aoa_to_sheet([
    ...baslik,
    ['Sıra', 'Ad Soyad', 'Öğrenci No', 'Katılım Durumu'],
    ...katilimcilar.map((k, i) => [
      i + 1,
      `${k.ad} ${k.soyad}`,
      k.ogrenci_no || '—',
      k.katildi === 1 ? 'Katıldı' : k.katildi === 0 ? 'Katılmadı' : 'Belirtilmedi',
    ]),
  ]);
  wsBaslik['!cols'] = [{ wch: 6 }, { wch: 24 }, { wch: 14 }, { wch: 16 }];

  const wb2 = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb2, wsBaslik, 'Yoklama');

  const tarihStr = etut?.tarih ? new Date(etut.tarih).toISOString().slice(0, 10) : 'tarih';
  XLSX.writeFile(wb2, `Etut_Yoklama_${etut?.ders_adi || 'etut'}_${tarihStr}.xlsx`);
  toast.success('Excel indirildi!');
}

// ══════════════════════════════════════════════════════════
// ORTAK ETÜTLERİ GÖRÜNTÜLE BİLEŞENİ
// ══════════════════════════════════════════════════════════
function EtutListesi({ onYeniEtut, etutler, loading, onDetay }) {
  return (
    <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
      <div style={{
        padding: '14px 18px', display: 'flex', justifyContent: 'space-between',
        alignItems: 'center', borderBottom: '1px solid var(--border)',
      }}>
        <div className="section-title" style={{ margin: 0 }}>📚 Oluşturulan Etütler</div>
        {onYeniEtut && (
          <button className="btn btn-primary btn-sm" onClick={onYeniEtut}>+ Yeni Etüt</button>
        )}
      </div>

      {loading ? (
        <div className="page-loader" style={{ minHeight: 120 }}><div className="spinner" /></div>
      ) : etutler.length === 0 ? (
        <div className="empty-state" style={{ padding: '40px 0' }}>
          <div style={{ fontSize: '2.5rem' }}>📚</div>
          <p>Henüz etüt oluşturulmamış</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {etutler.map((e, i) => (
            <div
              key={e.id}
              onClick={() => onDetay && onDetay(e)}
              style={{
                display: 'flex', alignItems: 'center', gap: 14,
                padding: '14px 18px',
                borderBottom: i < etutler.length - 1 ? '1px solid var(--border)' : 'none',
                cursor: onDetay ? 'pointer' : 'default',
                transition: 'background 0.15s',
              }}
              onMouseEnter={e2 => { if (onDetay) e2.currentTarget.style.background = 'var(--bg-elevated)'; }}
              onMouseLeave={e2 => { e2.currentTarget.style.background = 'transparent'; }}
            >
              <div style={{
                width: 44, height: 44, borderRadius: 12, flexShrink: 0,
                background: (e.ders_renk || '#3B82F6') + '20',
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.3rem',
              }}>📚</div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 700, fontSize: '0.9rem', marginBottom: 2 }}>
                  {e.ders_adi}
                  {e.konu && <span style={{ fontWeight: 400, color: 'var(--text-muted)', marginLeft: 6 }}>— {e.konu}</span>}
                </div>
                <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)', display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                  <span>👨‍🏫 {e.ogretmen_ad} {e.ogretmen_soyad}</span>
                  <span>📅 {formatTarih(e.tarih)}</span>
                  <span>⏰ {formatSaat(e.baslangic_saati)}{e.bitis_saati ? ` – ${formatSaat(e.bitis_saati)}` : ''}</span>
                  {e.salon && <span>🏫 Salon {e.salon}</span>}
                </div>
              </div>
              <div style={{ textAlign: 'right', flexShrink: 0 }}>
                <div style={{
                  display: 'inline-flex', alignItems: 'center', gap: 4,
                  padding: '4px 10px', borderRadius: 99,
                  background: 'var(--accent-dim)', color: 'var(--accent)',
                  fontSize: '0.78rem', fontWeight: 700,
                }}>
                  👤 {e.katilimci_sayisi || 0} öğrenci
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ══════════════════════════════════════════════════════════
// ÖĞRENCİ ARAMA + SINIF FİLTRELİ SEÇİM BİLEŞENİ
// ══════════════════════════════════════════════════════════
function OgrenciSecimListesi({ ogrenciler, siniflar, seciliIds, onToggle }) {
  const [aramaMetni, setAramaMetni] = useState('');
  const [seciliSinif, setSeciliSinif] = useState('');

  const getFiltered = (sinifId, search) => {
    const sinifObj = siniflar.find(s => String(s.id) === String(sinifId));
    const sinifAd = sinifObj?.ad ? sinifObj.ad.toLowerCase() : '';
    const normalizedSearch = (search || '').toLowerCase().trim();

    return ogrenciler.filter(o => {
      const adSoyad = `${o.ad || ''} ${o.soyad || ''}`.toLowerCase();
      const no = String(o.ogrenci_no || '').toLowerCase();
      const isimEslesmesi =
        normalizedSearch === '' ||
        adSoyad.includes(normalizedSearch) ||
        (no && no.includes(normalizedSearch));

      if (!sinifId) return isimEslesmesi;

      const oSinifId = o.sinif_id ? Number(o.sinif_id) : null;
      const fSinifId = Number(sinifId);
      const sinifIdEslesmesi = oSinifId === fSinifId;

      if (sinifIdEslesmesi) return isimEslesmesi;

      if (sinifAd) {
        const ogrSinifAd = String(
          o.sinif_adi || o.sinif || o.sinif?.ad || ''
        ).toLowerCase();
        return isimEslesmesi && ogrSinifAd.includes(sinifAd);
      }

      return false;
    });
  };

  const filtrelenmis = useMemo(
    () => getFiltered(seciliSinif, aramaMetni),
    [ogrenciler, siniflar, aramaMetni, seciliSinif]
  );

  const tumunuSec = () => {
    filtrelenmis.forEach(o => { if (!seciliIds.includes(o.id)) onToggle(o.id); });
  };
  const tumunuKaldir = () => {
    filtrelenmis.forEach(o => { if (seciliIds.includes(o.id)) onToggle(o.id); });
  };
  const handleSinifChange = (value) => {
    setSeciliSinif(value);
    if (!value) return;
    const hedefListe = getFiltered(value, aramaMetni);
    hedefListe.forEach(o => { if (!seciliIds.includes(o.id)) onToggle(o.id); });
  };

  return (
    <div>
      {/* Arama + Sınıf filtresi */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
        <input
          className="form-input"
          placeholder="🔍 İsim veya numara ara..."
          value={aramaMetni}
          onChange={e => setAramaMetni(e.target.value)}
          style={{ flex: 1, fontSize: '0.82rem' }}
        />
        <select
          className="form-select"
          value={seciliSinif}
          onChange={e => handleSinifChange(e.target.value)}
          style={{ width: 160, fontSize: '0.82rem' }}
        >
          <option value="">Tüm Sınıflar</option>
          {siniflar.map(s => <option key={s.id} value={s.id}>{s.ad}</option>)}
        </select>
      </div>

      {/* Hızlı seçim butonları */}
      <div style={{ display: 'flex', gap: 6, marginBottom: 8 }}>
        <button
          type="button"
          onClick={tumunuSec}
          className="btn btn-ghost btn-sm"
          style={{ fontSize: '0.75rem' }}
        >
          ✅ Filtrelenenleri Seç ({filtrelenmis.length})
        </button>
        <button
          type="button"
          onClick={tumunuKaldir}
          className="btn btn-ghost btn-sm"
          style={{ fontSize: '0.75rem' }}
        >
          ✕ Seçimi Kaldır
        </button>
        <span style={{ marginLeft: 'auto', fontSize: '0.78rem', color: 'var(--text-muted)', alignSelf: 'center' }}>
          {seciliIds.length} seçili
        </span>
      </div>

      {/* Liste */}
      <div style={{
        maxHeight: 220, overflowY: 'auto', border: '1px solid var(--border)',
        borderRadius: 10, display: 'flex', flexDirection: 'column',
      }}>
        {filtrelenmis.length === 0 ? (
          <div style={{ padding: '20px', textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.82rem' }}>
            Sonuç bulunamadı
          </div>
        ) : filtrelenmis.map(o => {
          const secili = seciliIds.includes(o.id);
          return (
            <label key={o.id} style={{
              display: 'flex', alignItems: 'center', gap: 10,
              padding: '8px 12px', cursor: 'pointer',
              background: secili ? 'var(--accent-dim)' : 'transparent',
              borderBottom: '1px solid var(--border-subtle)',
              transition: 'background 0.1s',
            }}>
              <input
                type="checkbox"
                checked={secili}
                onChange={() => onToggle(o.id)}
                style={{ accentColor: 'var(--accent)' }}
              />
              <div style={{ flex: 1, minWidth: 0 }}>
                <span style={{ fontSize: '0.85rem', fontWeight: secili ? 700 : 400 }}>
                  {o.ad} {o.soyad}
                </span>
                {o.ogrenci_no && (
                  <span style={{ marginLeft: 6, fontSize: '0.72rem', color: 'var(--text-muted)' }}>
                    #{o.ogrenci_no}
                  </span>
                )}
              </div>
              {o.sinif_adi && (
                <span style={{
                  fontSize: '0.7rem', padding: '2px 7px', borderRadius: 99,
                  background: 'var(--bg-elevated)', color: 'var(--text-muted)',
                  flexShrink: 0,
                }}>
                  {o.sinif_adi}
                </span>
              )}
            </label>
          );
        })}
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════
// ETÜ OLUŞTURMA MODAL
// ══════════════════════════════════════════════════════════
function EtutOlusturModal({ onClose, onSuccess, talepId = null, talepOgrenciId = null }) {
  const [ogretmenler, setOgretmenler] = useState([]);
  const [ogrenciler, setOgrenciler] = useState([]);
  const [siniflar, setSiniflar] = useState([]);
  const [dersler, setDersler] = useState([]);
  const [musaitSlotlar, setMusaitSlotlar] = useState([]);
  const [musaitLoading, setMusaitLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState({
    ogretmen_id: '',
    ders_id: '',
    tarih: new Date().toISOString().slice(0, 10),
    baslangic_saati: '',
    bitis_saati: '',
    sure_dakika: 60,
    salon: '',
    konu: '',
    aciklama: '',
    ogrenci_ids: talepOgrenciId ? [talepOgrenciId] : [],
  });

  useEffect(() => {
    Promise.all([
      axios.get('/ogretmenler-listesi').catch(() => ({ data: { data: [] } })),
      axios.get('/ogrenciler?limit=500').catch(() => ({ data: { data: [] } })),
      axios.get('/dersler').catch(() => ({ data: { data: [] } })),
      axios.get('/siniflar').catch(() => ({ data: { data: [] } })),
    ]).then(([oRes, ogrRes, dRes, sRes]) => {
      const raw = oRes.data?.data || [];
      setOgretmenler(raw.map(o => ({ ...o, _ogretmenler_id: o.og_id ?? o.ogretmen_id ?? o.id })));
      setOgrenciler(ogrRes.data?.data || []);
      setDersler(dRes.data?.data || []);
      setSiniflar(sRes.data?.data || []);
    });
  }, []);

  useEffect(() => {
    if (!form.ogretmen_id || !form.tarih) { setMusaitSlotlar([]); return; }
    setMusaitLoading(true);
    axios.get(`/etutler/ogretmen-musait/${form.ogretmen_id}?tarih=${form.tarih}`)
      .then(res => { if (res.data.success) setMusaitSlotlar(res.data.data?.musait || []); })
      .catch(() => setMusaitSlotlar([]))
      .finally(() => setMusaitLoading(false));
  }, [form.ogretmen_id, form.tarih]);

  const toggleOgrenci = (id) => {
    setForm(prev => ({
      ...prev,
      ogrenci_ids: prev.ogrenci_ids.includes(id)
        ? prev.ogrenci_ids.filter(x => x !== id)
        : [...prev.ogrenci_ids, id],
    }));
  };

  const handleSubmit = async () => {
    if (!form.ogretmen_id || !form.ders_id || !form.tarih || !form.baslangic_saati) {
      toast.error('Öğretmen, ders, tarih ve başlangıç saati zorunludur');
      return;
    }
    setSaving(true);
    try {
      await axios.post('/etutler', {
        ...form,
        ogretmen_id: parseInt(form.ogretmen_id, 10),
        ders_id: parseInt(form.ders_id, 10),
        talep_ids: talepId ? [talepId] : [],
      });
      toast.success('Etüt başarıyla oluşturuldu!');
      onSuccess();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Etüt oluşturulurken hata oluştu');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 720, maxHeight: '92vh', overflowY: 'auto' }}
        onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">📚 Yeni Etüt Oluştur</div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {/* Öğretmen + Ders */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div className="form-group">
              <label className="form-label">👨‍🏫 Öğretmen *</label>
              <select className="form-select" value={form.ogretmen_id}
                onChange={e => setForm(p => ({
                  ...p, ogretmen_id: parseInt(e.target.value, 10) || '',
                  baslangic_saati: '', bitis_saati: '',
                }))}>
                <option value="">Seçin</option>
                {ogretmenler.map(o => (
                  <option key={o._ogretmenler_id} value={o._ogretmenler_id}>
                    {o.ad} {o.soyad}{o.brans ? ` (${o.brans})` : ''}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">📖 Ders *</label>
              <select className="form-select" value={form.ders_id}
                onChange={e => setForm(p => ({ ...p, ders_id: parseInt(e.target.value, 10) || '' }))}>
                <option value="">Seçin</option>
                {dersler.map(d => <option key={d.id} value={d.id}>{d.ad}</option>)}
              </select>
            </div>
          </div>

          {/* Tarih */}
          <div className="form-group">
            <label className="form-label">📅 Tarih *</label>
            <input type="date" className="form-input" value={form.tarih}
              onChange={e => setForm(p => ({ ...p, tarih: e.target.value, baslangic_saati: '', bitis_saati: '' }))} />
          </div>

          {/* Müsait slotlar */}
          {form.ogretmen_id && form.tarih && (
            <div style={{ background: 'var(--bg-elevated)', borderRadius: 12, padding: 12 }}>
              <div style={{ fontSize: '0.82rem', fontWeight: 700, marginBottom: 8, color: 'var(--text-secondary)' }}>
                🕐 Öğretmen Müsait Saatler
                {musaitLoading && <span style={{ marginLeft: 8, fontWeight: 400, color: 'var(--text-muted)' }}>Yükleniyor...</span>}
              </div>
              {!musaitLoading && musaitSlotlar.length === 0 ? (
                <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>Bu gün müsait saat bulunamadı</div>
              ) : (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                  {musaitSlotlar.map((slot, i) => (
                    <button key={i} type="button"
                      onClick={() => setForm(p => ({ ...p, baslangic_saati: slot.bas, bitis_saati: slot.bit }))}
                      style={{
                        padding: '5px 13px', borderRadius: 99, fontSize: '0.8rem', fontWeight: 700,
                        cursor: 'pointer', border: '1.5px solid var(--accent)',
                        background: form.baslangic_saati === slot.bas ? 'var(--accent)' : 'var(--bg-card)',
                        color: form.baslangic_saati === slot.bas ? '#fff' : 'var(--accent)',
                        transition: 'all 0.15s',
                      }}>
                      {slot.bas} – {slot.bit}
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Saat + Salon */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
            <div className="form-group">
              <label className="form-label">⏰ Başlangıç *</label>
              <input type="time" className="form-input" value={form.baslangic_saati}
                onChange={e => setForm(p => ({ ...p, baslangic_saati: e.target.value }))} />
            </div>
            <div className="form-group">
              <label className="form-label">⏰ Bitiş</label>
              <input type="time" className="form-input" value={form.bitis_saati}
                onChange={e => setForm(p => ({ ...p, bitis_saati: e.target.value }))} />
            </div>
            <div className="form-group">
              <label className="form-label">🏫 Salon</label>
              <input className="form-input" placeholder="A101..." value={form.salon}
                onChange={e => setForm(p => ({ ...p, salon: e.target.value }))} />
            </div>
          </div>

          {/* Konu */}
          <div className="form-group">
            <label className="form-label">📝 Konu</label>
            <input className="form-input" placeholder="Türev, İntegral..." value={form.konu}
              onChange={e => setForm(p => ({ ...p, konu: e.target.value }))} />
          </div>

          {/* Öğrenci seçimi — sınıf filtreli + arama */}
          <div className="form-group">
            <label className="form-label" style={{ marginBottom: 8 }}>
              👤 Öğrenciler
            </label>
            <OgrenciSecimListesi
              ogrenciler={ogrenciler}
              siniflar={siniflar}
              seciliIds={form.ogrenci_ids}
              onToggle={toggleOgrenci}
            />
          </div>

          <div style={{ display: 'flex', gap: 10 }}>
            <button className="btn btn-primary" style={{ flex: 1, justifyContent: 'center' }}
              onClick={handleSubmit} disabled={saving}>
              {saving ? <><div className="spinner" style={{ width: 16, height: 16 }} /> Oluşturuluyor...</> : '✓ Etüt Oluştur'}
            </button>
            <button className="btn btn-secondary" onClick={onClose}>İptal</button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════
// YOKLAMA MODAL — Öğretmen ve Rehber için ortak
// ══════════════════════════════════════════════════════════
function YoklamaModal({ etut, onClose, onSuccess, sadeceBak = false }) {
  const [detay, setDetay] = useState(null);
  const [yoklamalar, setYoklamalar] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!etut?.id) return;
    setLoading(true);
    axios.get(`/etutler/${etut.id}`)
      .then(res => {
        if (res.data.success) {
          const d = res.data.data;
          setDetay(d);
          // Mevcut katılım durumunu yükle
          const init = {};
          (d.katilimcilar || []).forEach(k => {
            // katildi: 1=katıldı, 0=katılmadı, null=belirsiz
            init[k.ogrenci_id] = k.katildi === 1 ? true : k.katildi === 0 ? false : null;
          });
          setYoklamalar(init);
        }
      })
      .catch(() => toast.error('Detay yüklenemedi'))
      .finally(() => setLoading(false));
  }, [etut?.id]);

  const handleKaydet = async () => {
    if (sadeceBak) return;
    setSaving(true);
    try {
      const payload = Object.entries(yoklamalar)
        .filter(([, v]) => v !== null)
        .map(([ogrenci_id, katildi]) => ({
          ogrenci_id: parseInt(ogrenci_id, 10),
          katildi: katildi === true,
        }));

      if (payload.length === 0) {
        toast.error('Hiçbir öğrenci için işaret yapılmadı');
        setSaving(false);
        return;
      }

      await axios.put(`/etutler/${etut.id}/yoklama`, { yoklamalar: payload });
      toast.success('Yoklama kaydedildi!');
      onSuccess();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Kayıt sırasında hata oluştu');
    } finally {
      setSaving(false);
    }
  };

  const handleExcel = () => {
    if (!detay) return;
    exportEtutYoklamaExcel(detay, detay.katilimcilar || []);
  };

  const katildiSayisi = Object.values(yoklamalar).filter(v => v === true).length;
  const katilmadiSayisi = Object.values(yoklamalar).filter(v => v === false).length;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 560 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">
            {sadeceBak ? '📋 Yoklama Görüntüle' : '📋 Etüt Yoklaması'}
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <button className="btn btn-success btn-sm" onClick={handleExcel} title="Excel İndir">
              📥 Excel
            </button>
            <button className="modal-close" onClick={onClose}>✕</button>
          </div>
        </div>

        {loading ? (
          <div className="page-loader" style={{ minHeight: 120 }}><div className="spinner" /></div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {/* Etüt bilgisi */}
            <div style={{
              padding: '10px 14px', borderRadius: 10,
              background: (detay?.ders_renk || '#3B82F6') + '12',
              border: `1px solid ${detay?.ders_renk || '#3B82F6'}25`,
              fontSize: '0.82rem', color: 'var(--text-secondary)',
            }}>
              <strong>{detay?.ders_adi}</strong>
              {detay?.konu && ` — ${detay.konu}`}
              {' · '}{formatTarih(detay?.tarih)} {formatSaat(detay?.baslangic_saati)}
              {detay?.salon && ` · Salon ${detay.salon}`}
            </div>

            {/* Özet sayaç */}
            {(detay?.katilimcilar || []).length > 0 && (
              <div style={{ display: 'flex', gap: 8 }}>
                {[
                  { label: 'Katıldı', val: katildiSayisi, color: '#10B981' },
                  { label: 'Katılmadı', val: katilmadiSayisi, color: '#EF4444' },
                  { label: 'Belirsiz', val: (detay?.katilimcilar?.length || 0) - katildiSayisi - katilmadiSayisi, color: '#94A3B8' },
                ].map(item => (
                  <div key={item.label} style={{
                    flex: 1, padding: '8px 10px', borderRadius: 10,
                    background: item.color + '12', border: `1px solid ${item.color}25`, textAlign: 'center',
                  }}>
                    <div style={{ fontWeight: 800, fontSize: '1.1rem', color: item.color }}>{item.val}</div>
                    <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)' }}>{item.label}</div>
                  </div>
                ))}
              </div>
            )}

            {/* Yoklama listesi */}
            {(detay?.katilimcilar || []).length === 0 ? (
              <div className="empty-state"><p>Katılımcı eklenmemiş</p></div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 360, overflowY: 'auto' }}>
                {detay.katilimcilar.map(k => {
                  const durum = yoklamalar[k.ogrenci_id]; // true / false / null
                  return (
                    <div key={k.ogrenci_id} style={{
                      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                      padding: '10px 14px', background: 'var(--bg-elevated)', borderRadius: 10,
                      borderLeft: `3px solid ${durum === true ? '#10B981' : durum === false ? '#EF4444' : '#94A3B8'}`,
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <div className="avatar avatar-xs"
                          style={{ background: durum === true ? 'rgba(16,185,129,0.15)' : durum === false ? 'rgba(239,68,68,0.12)' : 'var(--bg-card)' }}>
                          {k.ad?.[0]}{k.soyad?.[0]}
                        </div>
                        <div>
                          <span style={{ fontWeight: 600, fontSize: '0.88rem' }}>{k.ad} {k.soyad}</span>
                          {k.ogrenci_no && <span style={{ marginLeft: 6, fontSize: '0.7rem', color: 'var(--text-muted)' }}>#{k.ogrenci_no}</span>}
                        </div>
                      </div>
                      {sadeceBak ? (
                        // Rehber sadece görebiliyor, değiştiremez
                        <span style={{
                          fontSize: '0.78rem', fontWeight: 700, padding: '4px 10px', borderRadius: 99,
                          background: durum === true ? 'rgba(16,185,129,0.12)' : durum === false ? 'rgba(239,68,68,0.12)' : 'var(--bg-card)',
                          color: durum === true ? '#10B981' : durum === false ? '#EF4444' : 'var(--text-muted)',
                        }}>
                          {durum === true ? '✅ Katıldı' : durum === false ? '❌ Katılmadı' : '⏳ Belirsiz'}
                        </span>
                      ) : (
                        // Öğretmen işaret edebiliyor
                        <div style={{ display: 'flex', gap: 6 }}>
                          <button type="button"
                            onClick={() => setYoklamalar(p => ({ ...p, [k.ogrenci_id]: true }))}
                            style={{
                              padding: '5px 11px', borderRadius: 8, border: 'none', cursor: 'pointer',
                              fontWeight: 700, fontSize: '0.78rem', transition: 'all 0.1s',
                              background: durum === true ? '#10B981' : 'var(--bg-card)',
                              color: durum === true ? '#fff' : 'var(--text-muted)',
                            }}>✅ Katıldı</button>
                          <button type="button"
                            onClick={() => setYoklamalar(p => ({ ...p, [k.ogrenci_id]: false }))}
                            style={{
                              padding: '5px 11px', borderRadius: 8, border: 'none', cursor: 'pointer',
                              fontWeight: 700, fontSize: '0.78rem', transition: 'all 0.1s',
                              background: durum === false ? '#EF4444' : 'var(--bg-card)',
                              color: durum === false ? '#fff' : 'var(--text-muted)',
                            }}>❌ Katılmadı</button>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}

            {/* Alt butonlar */}
            {!sadeceBak && (
              <button className="btn btn-primary" style={{ justifyContent: 'center' }}
                onClick={handleKaydet} disabled={saving}>
                {saving ? 'Kaydediliyor...' : '✓ Yoklamayı Kaydet'}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════
// ETÜ DETAY MODAL
// ══════════════════════════════════════════════════════════
function EtutDetayModal({ etut, onClose, onDeleted, userRol }) {
  const [detay, setDetay] = useState(null);
  const [loading, setLoading] = useState(true);

  // Silme yetkisi olan roller
  const canDelete = ['kurucu', 'ogrenci_isleri', 'rehber_ogretmen'].includes(userRol);

  const handleSil = async () => {
    if (!window.confirm('Bu etüdü tamamen silmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`/etutler/${etut.id}`);
      toast.success('Etüt başarıyla silindi');
      if (onDeleted) onDeleted(); // Listeyi yenile
      onClose();
    } catch (err) {
      toast.error('Silme işlemi başarısız');
    }
  };

  useEffect(() => {
    if (!etut?.id) return;
    axios.get(`/etutler/${etut.id}`)
      .then(res => { if (res.data.success) setDetay(res.data.data); })
      .finally(() => setLoading(false));
  }, [etut]);

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 560 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">📚 Etüt Detayı</div>
          <div style={{ display: 'flex', gap: 8 }}>
            {/* SİLME BUTONU */}
            {canDelete && (
              <button className="btn btn-danger btn-sm" onClick={handleSil}>
                🗑 Sil
              </button>
            )}
            {detay && (
              <button className="btn btn-success btn-sm"
                onClick={() => exportEtutYoklamaExcel(detay, detay.katilimcilar || [])}>
                📥 Excel
              </button>
            )}
            <button className="modal-close" onClick={onClose}>✕</button>
          </div>
        </div>
        {loading ? (
          <div className="page-loader" style={{ minHeight: 100 }}><div className="spinner" /></div>
        ) : detay ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div style={{
              padding: '14px 16px', borderRadius: 12,
              background: (detay.ders_renk || '#3B82F6') + '15',
              border: `1px solid ${detay.ders_renk || '#3B82F6'}30`,
            }}>
              <div style={{ fontWeight: 800, fontSize: '1.1rem', color: detay.ders_renk || 'var(--text-primary)' }}>
                {detay.ders_adi}
              </div>
              {detay.konu && <div style={{ color: 'var(--text-secondary)', marginTop: 4 }}>{detay.konu}</div>}
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              {[
                { icon: '👨‍🏫', label: 'Öğretmen', val: `${detay.ogretmen_ad} ${detay.ogretmen_soyad}` },
                { icon: '📅', label: 'Tarih', val: formatTarih(detay.tarih) },
                { icon: '⏰', label: 'Saat', val: `${formatSaat(detay.baslangic_saati)}${detay.bitis_saati ? ' – ' + formatSaat(detay.bitis_saati) : ''}` },
                { icon: '🏫', label: 'Salon', val: detay.salon || 'Belirtilmedi' },
              ].map(item => (
                <div key={item.label} style={{ padding: '10px 14px', background: 'var(--bg-elevated)', borderRadius: 10 }}>
                  <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginBottom: 4 }}>{item.icon} {item.label}</div>
                  <div style={{ fontWeight: 700, fontSize: '0.88rem' }}>{item.val}</div>
                </div>
              ))}
            </div>

            <div>
              <div style={{ fontWeight: 700, fontSize: '0.85rem', marginBottom: 10 }}>
                👥 Katılımcılar ({detay.katilimcilar?.length || 0})
              </div>
              {(detay.katilimcilar || []).length === 0 ? (
                <div style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Katılımcı yok</div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 280, overflowY: 'auto' }}>
                  {detay.katilimcilar.map(k => (
                    <div key={k.id} style={{
                      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                      padding: '8px 12px', background: 'var(--bg-elevated)', borderRadius: 8,
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <div className="avatar avatar-xs">{k.ad?.[0]}{k.soyad?.[0]}</div>
                        <span style={{ fontSize: '0.85rem', fontWeight: 600 }}>{k.ad} {k.soyad}</span>
                      </div>
                      <span style={{
                        fontSize: '0.75rem', fontWeight: 700, padding: '2px 8px', borderRadius: 99,
                        background: k.katildi === 1 ? 'rgba(16,185,129,0.1)' : k.katildi === 0 ? 'rgba(239,68,68,0.1)' : 'var(--bg-card)',
                        color: k.katildi === 1 ? '#10B981' : k.katildi === 0 ? '#EF4444' : 'var(--text-muted)',
                      }}>
                        {k.katildi === 1 ? '✅ Katıldı' : k.katildi === 0 ? '❌ Katılmadı' : '⏳ Bekleniyor'}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ) : <div className="empty-state"><p>Detay yüklenemedi</p></div>}
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════
// ANA SAYFA — Admin / Kurucu / Öğrenci İşleri
// ══════════════════════════════════════════════════════════
export function EtutYonetimiPage() {
  const { user } = useAuth();
  const [etutler, setEtutler] = useState([]);
  const [talepler, setTalepler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [seciliTalep, setSeciliTalep] = useState(null);
  const [detayEtut, setDetayEtut] = useState(null);
  const [aktifTab, setAktifTab] = useState('etutler');

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const [eRes, tRes] = await Promise.all([
        axios.get('/etutler'),
        axios.get('/rehberlik/etut-talepleri'),
      ]);
      if (eRes.data.success) setEtutler(eRes.data.data || []);
      if (tRes.data.success) setTalepler(tRes.data.data || []);
    } catch { toast.error('Veriler yüklenemedi'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { loadData(); }, [loadData]);

  const bekleyenTalepler = talepler.filter(t => t.durum === 'bekliyor');
  const DURUM_COLORS = {
    bekliyor: 'var(--accent)', onaylandi: '#10B981',
    reddedildi: '#EF4444', tamamlandi: '#3B82F6',
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div className="animate-fadeInUp" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
        <div>
          <h2 style={{ fontFamily: 'var(--font-ui)', fontSize: '1.5rem', fontWeight: 800 }}>📚 Etüt Yönetimi</h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', marginTop: 4 }}>
            Etüt oluştur, talepleri yönet, öğretmen–öğrenci eşleştir
          </p>
        </div>
        <button className="btn btn-primary" onClick={() => { setSeciliTalep(null); setShowModal(true); }}>
          + Etüt Oluştur
        </button>
      </div>

      <div className="animate-fadeInUp stagger-1" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12 }}>
        {[
          { label: 'Toplam Etüt', val: etutler.length, color: '#2563EB', icon: '📚' },
          { label: 'Bekleyen Talep', val: bekleyenTalepler.length, color: '#F59E0B', icon: '⏳' },
          { label: 'Bugün', val: etutler.filter(e => new Date(e.tarih).toDateString() === new Date().toDateString()).length, color: '#10B981', icon: '📅' },
        ].map(stat => (
          <div key={stat.label} className="stat-card" style={{ '--stat-color': stat.color, padding: 16 }}>
            <div style={{ fontSize: '1.5rem', marginBottom: 6 }}>{stat.icon}</div>
            <div style={{ fontFamily: 'var(--font-ui)', fontSize: '1.8rem', fontWeight: 900 }}>{stat.val}</div>
            <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: 4 }}>{stat.label}</div>
          </div>
        ))}
      </div>

      <div className="card animate-fadeInUp stagger-2" style={{ padding: '10px 14px' }}>
        <div style={{ display: 'flex', gap: 8 }}>
          {[
            { key: 'etutler', label: `📚 Etütler (${etutler.length})` },
            { key: 'talepler', label: `📋 Talepler (${talepler.length})${bekleyenTalepler.length > 0 ? ` — ${bekleyenTalepler.length} bekliyor` : ''}` },
          ].map(tab => (
            <button key={tab.key} onClick={() => setAktifTab(tab.key)} style={{
              padding: '8px 16px', borderRadius: 10, fontSize: '0.85rem', fontWeight: 600,
              cursor: 'pointer', border: '1.5px solid',
              background: aktifTab === tab.key ? 'var(--accent)' : 'var(--bg-card)',
              color: aktifTab === tab.key ? '#fff' : 'var(--text-secondary)',
              borderColor: aktifTab === tab.key ? 'var(--accent)' : 'var(--border)',
              transition: 'all 0.15s',
            }}>{tab.label}</button>
          ))}
        </div>
      </div>

      <div className="animate-fadeInUp stagger-3">
        {aktifTab === 'etutler' ? (
          <EtutListesi etutler={etutler} loading={loading}
            onYeniEtut={() => { setSeciliTalep(null); setShowModal(true); }}
            onDetay={setDetayEtut} />
        ) : (
          <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
            <div style={{ padding: '14px 18px', borderBottom: '1px solid var(--border)' }}>
              <div className="section-title" style={{ margin: 0 }}>📋 Öğrenci Etüt Talepleri</div>
            </div>
            {loading ? (
              <div className="page-loader" style={{ minHeight: 100 }}><div className="spinner" /></div>
            ) : talepler.length === 0 ? (
              <div className="empty-state" style={{ padding: '40px 0' }}><p>Talep bulunmuyor</p></div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {talepler.map((t, i) => (
                  <div key={t.id} style={{
                    display: 'flex', alignItems: 'center', gap: 14,
                    padding: '14px 18px',
                    borderBottom: i < talepler.length - 1 ? '1px solid var(--border)' : 'none',
                    borderLeft: `3px solid ${DURUM_COLORS[t.durum] || '#94A3B8'}`,
                  }}>
                    <div className="avatar avatar-sm">{t.ogrenci_ad?.[0]}{t.ogrenci_soyad?.[0]}</div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 700, fontSize: '0.88rem' }}>{t.ogrenci_ad} {t.ogrenci_soyad}</div>
                      <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)' }}>
                        {t.ders_adi}{t.konu ? ` — ${t.konu}` : ''}
                        {t.tercih_tarihi && <span style={{ marginLeft: 8 }}>📅 {formatTarih(t.tercih_tarihi)}</span>}
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexShrink: 0 }}>
                      <span style={{
                        background: (DURUM_COLORS[t.durum] || '#94A3B8') + '20',
                        color: DURUM_COLORS[t.durum] || '#94A3B8',
                        padding: '3px 10px', borderRadius: 99, fontSize: '0.75rem', fontWeight: 600,
                      }}>
                        {t.durum === 'bekliyor' ? '⏳ Bekliyor' : t.durum === 'onaylandi' ? '✅ Onaylandı' : t.durum === 'reddedildi' ? '❌ Reddedildi' : '✓ Tamamlandı'}
                      </span>
                      {t.durum === 'bekliyor' && (
                        <button className="btn btn-primary btn-sm"
                          onClick={() => { setSeciliTalep(t); setShowModal(true); }}>
                          📚 Etüt Oluştur
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>

      {showModal && (
        <EtutOlusturModal
          talepId={seciliTalep?.id || null}
          talepOgrenciId={null}
          onClose={() => setShowModal(false)}
          onSuccess={() => { setShowModal(false); loadData(); }}
        />
      )}
      {detayEtut && (
        <EtutDetayModal
          etut={detayEtut}
          onClose={() => setDetayEtut(null)}
          onDeleted={loadData} // Silme sonrası listeyi yeniler
          userRol={user?.rol}  // MODALA ROLÜ GÖNDERİYORUZ (Hatanın asıl çözümü)
        />
      )}
    </div>
  );
}

// ══════════════════════════════════════════════════════════
// ÖĞRETMEN ETÜTLERİM SAYFASI
// ══════════════════════════════════════════════════════════
export function OgretmenEtutleriPage() {
  const { user } = useAuth();
  const [etutler, setEtutler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [detayEtut, setDetayEtut] = useState(null);
  const [yoklamaEtut, setYoklamaEtut] = useState(null);

  const loadEtutler = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get('/etutler/benim');
      if (res.data.success) setEtutler(res.data.data || []);
    } catch { toast.error('Etütler yüklenemedi'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { loadEtutler(); }, [loadEtutler]);

  const bugun = new Date().toDateString();
  const bugunEtutler = etutler.filter(e => new Date(e.tarih).toDateString() === bugun);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div className="animate-fadeInUp">
        <h2 style={{ fontFamily: 'var(--font-ui)', fontSize: '1.3rem', fontWeight: 800 }}>📚 Etütlerim</h2>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', marginTop: 4 }}>Atanan etütleriniz ve yoklama işlemleri</p>
      </div>

      {bugunEtutler.length > 0 && (
        <div className="card animate-fadeInUp stagger-1" style={{
          background: 'linear-gradient(135deg, rgba(37,99,235,0.08) 0%, var(--bg-card) 100%)',
          border: '1px solid rgba(37,99,235,0.15)',
        }}>
          <div className="section-title" style={{ marginBottom: 10 }}>📅 Bugünkü Etütlerim</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {bugunEtutler.map(e => (
              <div key={e.id} style={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                padding: '10px 14px', background: 'var(--bg-elevated)', borderRadius: 10,
                borderLeft: `3px solid ${e.ders_renk || '#3B82F6'}`,
              }}>
                <div>
                  <div style={{ fontWeight: 700, fontSize: '0.88rem' }}>{e.ders_adi}{e.konu ? ` — ${e.konu}` : ''}</div>
                  <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>
                    ⏰ {formatSaat(e.baslangic_saati)}{e.bitis_saati ? ` – ${formatSaat(e.bitis_saati)}` : ''}
                    {e.salon && ` · Salon ${e.salon}`} · {e.katilimci_sayisi || 0} öğrenci
                  </div>
                </div>
                <button className="btn btn-primary btn-sm" onClick={() => setYoklamaEtut(e)}>
                  📋 Yoklama Al
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      <EtutListesi etutler={etutler} loading={loading}
        onDetay={e => setYoklamaEtut(e)} />

      {detayEtut && <EtutDetayModal etut={detayEtut} onClose={() => setDetayEtut(null)} />}
      {yoklamaEtut && (
        <YoklamaModal
          etut={yoklamaEtut}
          sadeceBak={false}
          onClose={() => setYoklamaEtut(null)}
          onSuccess={() => { setYoklamaEtut(null); loadEtutler(); }}
        />
      )}
    </div>
  );
}

// ══════════════════════════════════════════════════════════
// REHBER ÖĞRETMEN — ETÜTLERİ GÖRÜNTÜLE + YOKLAMA İZLE
// ══════════════════════════════════════════════════════════
export function RehberEtutYonetimiPage() {
  const { user } = useAuth();
  const [etutler, setEtutler] = useState([]);
  const [talepler, setTalepler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [seciliTalep, setSeciliTalep] = useState(null);
  const [yoklamaEtut, setYoklamaEtut] = useState(null);
  const [aktifTab, setAktifTab] = useState('etutler');

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const [eRes, tRes] = await Promise.all([
        axios.get('/etutler'),
        axios.get('/rehberlik/etut-talepleri'),
      ]);
      if (eRes.data.success) setEtutler(eRes.data.data || []);
      if (tRes.data.success) setTalepler(tRes.data.data || []);
    } catch { toast.error('Veriler yüklenemedi'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { loadData(); }, [loadData]);

  const bekleyenTalepler = talepler.filter(t => t.durum === 'bekliyor');
  const DURUM_COLORS = {
    bekliyor: 'var(--accent)', onaylandi: '#10B981',
    reddedildi: '#EF4444', tamamlandi: '#3B82F6',
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div className="animate-fadeInUp" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
        <div>
          <h2 style={{ fontFamily: 'var(--font-ui)', fontSize: '1.5rem', fontWeight: 800 }}>📚 Etüt Yönetimi</h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', marginTop: 4 }}>
            Etüt oluştur, talepleri incele, yoklamaları görüntüle
          </p>
        </div>
        <button className="btn btn-primary" onClick={() => { setSeciliTalep(null); setShowModal(true); }}>
          + Etüt Oluştur
        </button>
      </div>

      <div className="animate-fadeInUp stagger-1" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12 }}>
        {[
          { label: 'Toplam Etüt', val: etutler.length, color: '#2563EB', icon: '📚' },
          { label: 'Bekleyen Talep', val: bekleyenTalepler.length, color: '#F59E0B', icon: '⏳' },
          { label: 'Bugün', val: etutler.filter(e => new Date(e.tarih).toDateString() === new Date().toDateString()).length, color: '#10B981', icon: '📅' },
        ].map(stat => (
          <div key={stat.label} className="stat-card" style={{ '--stat-color': stat.color, padding: 16 }}>
            <div style={{ fontSize: '1.5rem', marginBottom: 6 }}>{stat.icon}</div>
            <div style={{ fontFamily: 'var(--font-ui)', fontSize: '1.8rem', fontWeight: 900 }}>{stat.val}</div>
            <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: 4 }}>{stat.label}</div>
          </div>
        ))}
      </div>

      <div className="card animate-fadeInUp stagger-2" style={{ padding: '10px 14px' }}>
        <div style={{ display: 'flex', gap: 8 }}>
          {[
            { key: 'etutler', label: `📚 Etütler (${etutler.length})` },
            { key: 'talepler', label: `📋 Talepler (${talepler.length})${bekleyenTalepler.length > 0 ? ` — ${bekleyenTalepler.length} bekliyor` : ''}` },
          ].map(tab => (
            <button key={tab.key} onClick={() => setAktifTab(tab.key)} style={{
              padding: '8px 16px', borderRadius: 10, fontSize: '0.85rem', fontWeight: 600,
              cursor: 'pointer', border: '1.5px solid',
              background: aktifTab === tab.key ? 'var(--accent)' : 'var(--bg-card)',
              color: aktifTab === tab.key ? '#fff' : 'var(--text-secondary)',
              borderColor: aktifTab === tab.key ? 'var(--accent)' : 'var(--border)',
              transition: 'all 0.15s',
            }}>{tab.label}</button>
          ))}
        </div>
      </div>

      <div className="animate-fadeInUp stagger-3">
        {aktifTab === 'etutler' ? (
          // Rehber yoklamayı sadece görüntüleyebilir (sadeceBak=true)
          <EtutListesi etutler={etutler} loading={loading}
            onYeniEtut={() => { setSeciliTalep(null); setShowModal(true); }}
            onDetay={e => setYoklamaEtut(e)} />
        ) : (
          <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
            <div style={{ padding: '14px 18px', borderBottom: '1px solid var(--border)' }}>
              <div className="section-title" style={{ margin: 0 }}>📋 Öğrenci Etüt Talepleri</div>
            </div>
            {loading ? (
              <div className="page-loader" style={{ minHeight: 100 }}><div className="spinner" /></div>
            ) : talepler.length === 0 ? (
              <div className="empty-state" style={{ padding: '40px 0' }}><p>Talep bulunmuyor</p></div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {talepler.map((t, i) => (
                  <div key={t.id} style={{
                    display: 'flex', alignItems: 'center', gap: 14,
                    padding: '14px 18px',
                    borderBottom: i < talepler.length - 1 ? '1px solid var(--border)' : 'none',
                    borderLeft: `3px solid ${DURUM_COLORS[t.durum] || '#94A3B8'}`,
                  }}>
                    <div className="avatar avatar-sm">{t.ogrenci_ad?.[0]}{t.ogrenci_soyad?.[0]}</div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 700, fontSize: '0.88rem' }}>{t.ogrenci_ad} {t.ogrenci_soyad}</div>
                      <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)' }}>
                        {t.ders_adi}{t.konu ? ` — ${t.konu}` : ''}
                        {t.tercih_tarihi && <span style={{ marginLeft: 8 }}>📅 {formatTarih(t.tercih_tarihi)}</span>}
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexShrink: 0 }}>
                      <span style={{
                        background: (DURUM_COLORS[t.durum] || '#94A3B8') + '20',
                        color: DURUM_COLORS[t.durum] || '#94A3B8',
                        padding: '3px 10px', borderRadius: 99, fontSize: '0.75rem', fontWeight: 600,
                      }}>
                        {t.durum === 'bekliyor' ? '⏳ Bekliyor' : t.durum === 'onaylandi' ? '✅ Onaylandı' : t.durum === 'reddedildi' ? '❌ Reddedildi' : '✓ Tamamlandı'}
                      </span>
                      {t.durum === 'bekliyor' && (
                        <button className="btn btn-primary btn-sm"
                          onClick={() => { setSeciliTalep(t); setShowModal(true); }}>
                          📚 Etüt Oluştur
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>

      {showModal && (
        <EtutOlusturModal
          talepId={seciliTalep?.id || null}
          talepOgrenciId={null}
          onClose={() => setShowModal(false)}
          onSuccess={() => { setShowModal(false); loadData(); }}
        />
      )}

      {/* Rehber yoklamayı sadece görüntüler, kaydedemez */}
      {yoklamaEtut && (
        <YoklamaModal
          etut={yoklamaEtut}
          sadeceBak={true}
          onClose={() => setYoklamaEtut(null)}
          onSuccess={() => setYoklamaEtut(null)}
        />
      )}
    </div>
  );
}

// ══════════════════════════════════════════════════════════
// ÖĞRENCİ ETÜTLERİM SAYFASI
// ══════════════════════════════════════════════════════════
export function OgrenciEtutleriPage() {
  const [etutler, setEtutler] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('/etutler/ogrenci-etutlerim')
      .then(res => { if (res.data.success) setEtutler(res.data.data || []); })
      .finally(() => setLoading(false));
  }, []);

  const katildi = etutler.filter(e => e.katildi === 1).length;
  const katilmadi = etutler.filter(e => e.katildi === 0).length;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div className="animate-fadeInUp">
        <h2 style={{ fontFamily: 'var(--font-ui)', fontSize: '1.3rem', fontWeight: 800 }}>📚 Etütlerim</h2>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', marginTop: 4 }}>Planlanmış ve geçmiş etütleriniz</p>
      </div>

      {etutler.length > 0 && (
        <div className="grid-2 animate-fadeInUp stagger-1">
          <div className="card" style={{ background: 'linear-gradient(135deg, rgba(16,185,129,0.08) 0%, var(--bg-card) 100%)' }}>
            <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginBottom: 6 }}>✅ Katıldığım</div>
            <div style={{ fontFamily: 'var(--font-ui)', fontSize: '2rem', fontWeight: 900, color: '#10B981' }}>{katildi}</div>
            <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: 4 }}>{etutler.length} toplam etütten</div>
          </div>
          <div className="card" style={{ background: 'linear-gradient(135deg, rgba(239,68,68,0.06) 0%, var(--bg-card) 100%)' }}>
            <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginBottom: 6 }}>❌ Katılmadığım</div>
            <div style={{ fontFamily: 'var(--font-ui)', fontSize: '2rem', fontWeight: 900, color: '#EF4444' }}>{katilmadi}</div>
            <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: 4 }}>kayıp etüt</div>
          </div>
        </div>
      )}

      <div className="card animate-fadeInUp stagger-2">
        <div className="section-title" style={{ marginBottom: 16 }}>📋 Etüt Geçmişim</div>
        {loading ? (
          <div className="page-loader" style={{ minHeight: 100 }}><div className="spinner" /></div>
        ) : etutler.length === 0 ? (
          <div className="empty-state"><div style={{ fontSize: '2rem' }}>📚</div><p>Henüz etüdiniz planlanmamış</p></div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {etutler.map(e => (
              <div key={e.id} style={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                padding: '12px 16px', background: 'var(--bg-elevated)', borderRadius: 12,
                borderLeft: `4px solid ${e.ders_renk || '#3B82F6'}`,
              }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: '0.9rem', color: e.ders_renk || 'var(--text-primary)' }}>
                    {e.ders_adi}
                    {e.konu && <span style={{ fontWeight: 400, color: 'var(--text-muted)', marginLeft: 6, fontSize: '0.82rem' }}>— {e.konu}</span>}
                  </div>
                  <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginTop: 4, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                    <span>👨‍🏫 {e.ogretmen_ad} {e.ogretmen_soyad}</span>
                    <span>📅 {formatTarih(e.tarih)}</span>
                    <span>⏰ {formatSaat(e.baslangic_saati)}</span>
                    {e.salon && <span>🏫 Salon {e.salon}</span>}
                  </div>
                </div>
                <div style={{
                  padding: '5px 12px', borderRadius: 99, fontSize: '0.78rem', fontWeight: 700,
                  background: e.katildi === 1 ? 'rgba(16,185,129,0.1)' : e.katildi === 0 ? 'rgba(239,68,68,0.1)' : 'var(--bg-card)',
                  color: e.katildi === 1 ? '#10B981' : e.katildi === 0 ? '#EF4444' : 'var(--text-muted)',
                }}>
                  {e.katildi === 1 ? '✅ Katıldım' : e.katildi === 0 ? '❌ Katılmadım' : '⏳ Planlandı'}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════
// VELİ — ÇOCUĞUN ETÜTLERİ
// ══════════════════════════════════════════════════════════
export function VeliEtutleriPage() {
  const [etutler, setEtutler] = useState([]);
  const [ozet, setOzet] = useState({ toplam: 0, katildi: 0, katilmadi: 0, belirsiz: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('/etutler/veli-cocuk-etutleri')
      .then(res => {
        if (res.data.success) {
          setEtutler(res.data.data || []);
          setOzet(res.data.ozet || {});
        }
      })
      .finally(() => setLoading(false));
  }, []);

  const katilimOrani = ozet.toplam > 0 ? ((ozet.katildi / ozet.toplam) * 100).toFixed(1) : '0';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div className="animate-fadeInUp">
        <h2 style={{ fontFamily: 'var(--font-ui)', fontSize: '1.3rem', fontWeight: 800 }}>📚 Çocuğumun Etütleri</h2>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', marginTop: 4 }}>Düzenlenmiş etütler ve katılım durumu</p>
      </div>

      <div className="grid-2 animate-fadeInUp stagger-1">
        <div className="card" style={{ background: 'linear-gradient(135deg, var(--accent-dim) 0%, var(--bg-card) 100%)' }}>
          <div className="section-title" style={{ marginBottom: 10 }}>📊 Etüt Katılım Oranı</div>
          <div style={{ fontSize: '3rem', fontWeight: 900, color: 'var(--accent)', fontFamily: 'var(--font-ui)' }}>
            %{katilimOrani}
          </div>
          <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)', marginTop: 6 }}>
            {ozet.toplam} etütten {ozet.katildi} tanesine katılım
          </div>
          <div style={{ marginTop: 14, padding: '10px 14px', background: 'var(--bg-elevated)', borderRadius: 10, fontSize: '0.8rem' }}>
            💡 Dershane etüt saatlerini takip etmenizi kolaylaştırmak için bu sayfa hazırlandı.
          </div>
        </div>
        <div className="card">
          <div className="section-title" style={{ marginBottom: 12 }}>📋 Özet</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {[
              { label: 'Toplam Etüt', val: ozet.toplam, color: '#2563EB', icon: '📚' },
              { label: 'Katıldı', val: ozet.katildi, color: '#10B981', icon: '✅' },
              { label: 'Katılmadı', val: ozet.katilmadi, color: '#EF4444', icon: '❌' },
              { label: 'Planlandı', val: ozet.belirsiz, color: '#F59E0B', icon: '⏳' },
            ].map(item => (
              <div key={item.label} style={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                padding: '8px 12px', background: 'var(--bg-elevated)', borderRadius: 8,
              }}>
                <span style={{ fontSize: '0.85rem' }}>{item.icon} {item.label}</span>
                <span style={{ fontWeight: 800, color: item.color, fontFamily: 'var(--font-ui)' }}>{item.val}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="card animate-fadeInUp stagger-2">
        <div className="section-title" style={{ marginBottom: 16 }}>🗓 Etüt Detayları</div>
        {loading ? (
          <div className="page-loader" style={{ minHeight: 100 }}><div className="spinner" /></div>
        ) : etutler.length === 0 ? (
          <div className="empty-state"><p>Henüz etüt planlanmamış</p></div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {etutler.map(e => (
              <div key={e.id} style={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                padding: '12px 16px', background: 'var(--bg-elevated)', borderRadius: 12,
                borderLeft: `4px solid ${e.katildi === 1 ? '#10B981' : e.katildi === 0 ? '#EF4444' : '#F59E0B'}`,
              }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: '0.9rem' }}>
                    {e.ders_adi}
                    {e.konu && <span style={{ fontWeight: 400, color: 'var(--text-muted)', marginLeft: 6, fontSize: '0.82rem' }}>— {e.konu}</span>}
                  </div>
                  <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginTop: 4, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                    <span>👨‍🏫 {e.ogretmen_ad} {e.ogretmen_soyad}</span>
                    <span>📅 {formatTarih(e.tarih)}</span>
                    <span>⏰ {formatSaat(e.baslangic_saati)}</span>
                    {e.salon && <span>🏫 Salon {e.salon}</span>}
                  </div>
                </div>
                <div style={{
                  padding: '5px 12px', borderRadius: 99, fontSize: '0.78rem', fontWeight: 700, flexShrink: 0,
                  background: e.katildi === 1 ? 'rgba(16,185,129,0.12)' : e.katildi === 0 ? 'rgba(239,68,68,0.12)' : 'rgba(245,158,11,0.12)',
                  color: e.katildi === 1 ? '#10B981' : e.katildi === 0 ? '#EF4444' : '#F59E0B',
                }}>
                  {e.katildi === 1 ? '✅ Katıldı' : e.katildi === 0 ? '❌ Katılmadı' : '⏳ Planlandı'}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
